import K8ClassesCreatedPanel from './component'

export default K8ClassesCreatedPanel
